import React, { useState } from "react";
import { useLogMonitoring } from "../../../hooks/use-log-monitoring";

const LogMonitorContent: React.FC = () => {
    const { logs, clearLogs } = useLogMonitoring();
    const [filter, setFilter] = useState<"all" | "error" | "warning" | "info">("all");

    const filteredLogs = logs.filter((log) => filter === "all" || log.type === filter);

    const downloadLogs = () => {
        const content = filteredLogs
            .map(
                (log) =>
                    `[${new Date(log.timestamp).toLocaleString("fa-IR")}] ${log.type.toUpperCase()}: ${log.message}${
                        log.stack ? "\nStack: " + log.stack : ""
                    }\n`
            )
            .join("\n");

        const blob = new Blob([content], { type: "text/plain" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `logs-${new Date().toISOString()}.txt`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    };

    return (
        <div className="flex flex-col h-full bg-gray-100">
            {/* نوار ابزار */}
            <div className="flex items-center justify-between p-4 border-b">
                <div className="flex items-center space-x-4">
                    <select value={filter} onChange={(e) => setFilter(e.target.value as any)} className="px-3 py-1 border rounded-md">
                        <option value="all">همه</option>
                        <option value="error">خطاها</option>
                        <option value="warning">هشدارها</option>
                        <option value="info">اطلاعات</option>
                    </select>
                    <button onClick={downloadLogs} className="px-4 py-1 text-white bg-blue-500 rounded-md hover:bg-blue-600">
                        دانلود لاگ‌ها
                    </button>
                    <button onClick={clearLogs} className="px-4 py-1 text-white bg-red-500 rounded-md hover:bg-red-600">
                        پاک کردن لاگ‌ها
                    </button>
                </div>
                <div className="text-sm text-gray-500">{filteredLogs.length} لاگ نمایش داده شده</div>
            </div>

            {/* لیست لاگ‌ها */}
            <div className="flex-1 overflow-y-auto p-4 space-y-4">
                {filteredLogs.map((log) => (
                    <div
                        key={log.id}
                        className={`p-4 rounded-lg ${
                            log.type === "error" ? "bg-red-100" : log.type === "warning" ? "bg-yellow-100" : "bg-blue-100"
                        }`}>
                        <div className="flex items-center justify-between">
                            <span
                                className={`text-sm font-semibold ${
                                    log.type === "error" ? "text-red-700" : log.type === "warning" ? "text-yellow-700" : "text-blue-700"
                                }`}>
                                {log.type === "error" ? "خطا" : log.type === "warning" ? "هشدار" : "اطلاعات"}
                            </span>
                            <span className="text-sm text-gray-500">{new Date(log.timestamp).toLocaleString("fa-IR")}</span>
                        </div>
                        <p className="mt-2 text-gray-700">{log.message}</p>
                        {log.stack && <pre className="mt-2 p-2 bg-white rounded text-sm overflow-x-auto">{log.stack}</pre>}
                    </div>
                ))}
            </div>
        </div>
    );
};

export const LogMonitor = LogMonitorContent;
